// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FEtA","left":"styles_left__7gOXR"};